import TruckCover from '@src/common/assets/truck-cover.png';
import { useTranslation } from 'react-i18next';

export const TruckPanel = () => {
  const { t } = useTranslation();
  return (
    <img
      src={TruckCover}
      alt={t('imageDescription.truck')}
      style={{
        height: '100%',
        width: '100%',
        objectFit: 'cover',
      }}
    />
  );
};
